// List of third party items added to the window that will be
// removed with every chapter change.
const blacklist = [
    'webpackJsonp',
    '_babelPolyfill',
    'webpackJsonpdaznPlayer',
] as const;

// List of third party items added to the window object that will
// NOT be included in any warning messages about their removal.
const thirdPartyWhitelist = [
    'google_tag_data',
    'gaplugins',
    'gaGlobal',
    'gaData',
    'GoogleAnalyticsObject',
    'ga',
    'vwo_$',
    'VWO',
    '_vwo_exp',
    '_vwo_exp_ids',
    '_vwo_server_url',
    '_vis_opt_queue',
    '_vis_opt_check_segment',
    '_vwo_evq',
    '_vwo_ev',
    '_vwo_t',
    '_vwo_api_section_callback',
    '_vwo_s',
    '_vwo_campaignData',
    '_vis_opt_top_initialize',
    '_vis_opt_bottom_initialize',
    '_vis_opt_goal_conversion',
    '_vis_opt_revenue_conversion',
    '_vis_opt_get_campaign_xPath',
    '_vis_opt_pause',
    '_vis_opt_readCookie',
    '_vis_opt_createCookie',
    '_vis_opt_element_loaded',
    '_vis_opt_GA_track',
    '_vis_opt_register_conversion',
    '_vis_opt_experiment_id',
    '_vwo_settings_timed_out',
    'vis_opt_cookiedays',
    '___vwo',
    '__nls',
    '_vis_debug',
    '_vwo_ip',
    '_vwo_geo',
    '_vwo_pc_custom',
    '_vwo_pc',
    '_vwo_library_timer',
    '_vis_opt_lib',
    '_vis_opt_heatmap',
    '_vwo_acc_id',
    '_vis_opt_file',
    '_vwo_css',
    '_vwo_cookieDomain',
    '_vwo_code',
    '_vwo_settings_timer',
    '_vwo_settings_timed_out',
    '_vwo_style',
    '_vwo_text',
    '_vwo_text_node',
    '_vwod_insertSidebarMarkup',
    'VWO_d',
    '_vis_opt_comb_name',
    '_vwo_uuid',
    '_vwo_survey_cb',
    '_vwo_surveySettings',
    'vwo_iehack_queue',
    '_vwo_pa',
    '_vwo_opa_cb',
    '_vwo_worker_cb',
] as const;

export { blacklist, thirdPartyWhitelist };
